import Typography from '../../../typography';
import type { TypographyProps } from '../../../typography';
import { ArrowRightOutlined } from '@icon';
import mergeStyleProps from '@lib/utils/styles/mergeStyleProps';
import React from 'react';
import { useTheme } from 'styled-components';

interface ActionCardCountRightProps
  extends Omit<TypographyProps<any, any>, 'display' | 'variant' | 'style'> {
  showChevron?: boolean;
  style?: React.CSSProperties;
}

const ActionCardCountRight: React.FunctionComponent<ActionCardCountRightProps> = (props) => {
  const { style, showChevron, className, children, ...rest } = props;
  const theme = useTheme();

  return (
    <div
      style={mergeStyleProps(
        {
          paddingTop: 4,
          paddingBottom: 4,
          paddingLeft: 12,
          paddingRight: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        style,
      )}
      className={className}
    >
      <Typography
        {...rest}
        display="body2"
        variant="strong"
        style={{ color: theme.color.tint.tertiary }}
      >
        {children}
      </Typography>
      {showChevron ? (
        <ArrowRightOutlined
          width={20}
          height={20}
          color={theme.color.tint.tertiary}
          style={{ marginLeft: 12 }}
        />
      ) : null}
    </div>
  );
};

export default ActionCardCountRight;
